import { types, IEditorsPerGroup, EditorsPerGroupActionsType } from '../types/editorsPerGroup'

export const initialState = {}

export const editorsPerGroup = (
  state = initialState,
  action: EditorsPerGroupActionsType
): IEditorsPerGroup => {
  switch (action.type) {
    case types.GET_GROUP_EDITORS__STARTED:
      return { ...state, [action.groupId]: { items: null, totalCount: null, isLoading: true, isFailed: false } }
    case types.GET_GROUP_EDITORS__SUCCESS:
    case types.GET_GROUP_EDITORS__FAILURE:
      return { ...state, [action.groupId]: action.editorsData }
    case types.INVALIDATE_GROUP_EDITORS:
      const groupEditorsData = { ...state[action.groupId], items: null, totalCount: null }
      return { ...state, [action.groupId]: groupEditorsData }
    default:
      return state
  }
}
